import React from 'react';
import './outletSale.css';

const inr = (n) => `₹${(Number(n) || 0).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;

/**
 * Sales Report — Outlet-wise Sales. Shown only when the period has at least one
 * outlet sale. Ordinary TSR sales are one "Regular TSR" row, so the rows add up
 * to Total Sales. Gross profit is computed as the summary computes it: the
 * recorded food cost of each outlet's lines, plus its Not-in-Menu revenue costed
 * at the measured food-cost ratio — marked ≈ when that estimate is in it; "—"
 * when nothing could be costed.
 */
export default function OutletWiseSales({ rows = [] }) {
  if (!rows.some((r) => r.outlet)) return null;
  const total = rows.reduce((t, r) => t + (Number(r.sales) || 0), 0);
  const discount = rows.reduce((t, r) => t + (Number(r.discount) || 0), 0);
  const anyEstimated = rows.some((r) => r.gross_profit != null && r.gross_profit_estimated);
  return (
    <div className="trends-wrapper report-enter-card ows-card" id="outlet-wise-sales">
      <div className="ows-header">
        <h2 className="section-title ows-title" style={{ margin: 0, fontSize: 16, fontWeight: 600, color: '#000' }}>Outlet-wise Sales</h2>
      </div>
      <div className="ows-table-wrap">
        <table className="ows-table" style={{ width: '100%' }}>
          <thead className="ows-thead">
            <tr>
              <th className="ows-th ows-th-outlet">Outlet</th>
              <th className="ows-th ows-th-days">Days</th>
              <th className="ows-th ows-th-num">Sales</th>
              <th className="ows-th ows-th-num">Discount</th>
              <th className="ows-th ows-th-gp">Gross Profit</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => {
              const hasDisc = Number(r.discount) > 0;
              return (
                <tr key={r.label} className="ows-row">
                  <td className="ows-td ows-td-outlet">{r.label}</td>
                  <td className="ows-td ows-td-days">{r.days}</td>
                  <td className="ows-td ows-td-sales">{inr(r.sales)}</td>
                  <td className={`ows-td ows-td-discount ${hasDisc ? 'has-discount' : ''}`}>{inr(r.discount)}</td>
                  <td className="ows-td ows-td-gp">
                    {r.gross_profit == null ? '—' : `${r.gross_profit_estimated ? '≈ ' : ''}${inr(r.gross_profit)}`}
                  </td>
                </tr>
              );
            })}
          </tbody>
          <tfoot className="ows-tfoot">
            <tr>
              <td className="ows-tfoot-outlet"><strong>TOTAL</strong></td>
              <td className="ows-td-days" />
              <td className="ows-tfoot-sales"><strong>{inr(total)}</strong></td>
              <td className="ows-tfoot-discount">{inr(discount)}</td>
              <td className="ows-td-gp" />
            </tr>
          </tfoot>
        </table>
      </div>
      {anyEstimated && (
        <p className="ows-note">
          ≈ Gross profit includes an estimated cost for Not-in-Menu revenue, at the food-cost ratio of the costed dishes.
        </p>
      )}
    </div>
  );
}
